import { render, staticRenderFns } from "./UserManualSelect.vue?vue&type=template&id=923efa84&scoped=true"
import script from "./UserManualSelect.vue?vue&type=script&lang=js"
export * from "./UserManualSelect.vue?vue&type=script&lang=js"
import style0 from "./UserManualSelect.vue?vue&type=style&index=0&id=923efa84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923efa84",
  null
  
)

export default component.exports